import { Github, Linkedin, Twitter } from 'lucide-react';
import { usePublicConfig } from '../context';

const socials = [
  { icon: Twitter, href: 'https://twitter.com', label: 'Twitter' },
  { icon: Linkedin, href: 'https://linkedin.com', label: 'LinkedIn' },
  { icon: Github, href: 'https://github.com', label: 'GitHub' },
];

export const Footer = () => {
  const { config: publicConfig } = usePublicConfig();
  const chamaName = publicConfig?.name ?? 'LoopFund';

  return (
  <footer className="border-t border-slate-200 bg-white py-10 text-sm text-slate-500 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-400">
    <div className="mx-auto flex max-w-6xl flex-col gap-6 px-6 sm:flex-row sm:items-start sm:justify-between">
      <div>
        <span className="font-display text-lg font-semibold text-slate-900 dark:text-white">
          LoopFund Platform
        </span>
        <p className="mt-2 max-w-sm text-xs text-slate-500 dark:text-slate-400">
          Professional chama management for the modern era. {chamaName} is our showcase—your chama could be next.
        </p>
        <div className="mt-4 space-y-1 text-xs">
          <p>
            <a href="tel:+254743269238" className="hover:text-brand-600 dark:hover:text-brand-300">
              📞 0743 269 238
            </a>
          </p>
          <p>
            <a href="mailto:info@gritagencies.co.ke" className="hover:text-brand-600 dark:hover:text-brand-300">
              ✉️ info@gritagencies.co.ke
            </a>
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <div className="text-xs font-semibold uppercase tracking-wider text-slate-900 dark:text-white">
          Quick links
        </div>
        <a href="/apply" className="text-xs hover:text-brand-600 dark:hover:text-brand-300">
          Explore demo
        </a>
        <a href="/login" className="text-xs hover:text-brand-600 dark:hover:text-brand-300">
          Member login
        </a>
        <a href="tel:+254743269238" className="text-xs hover:text-brand-600 dark:hover:text-brand-300">
          Get started
        </a>
      </div>
    </div>
    <div className="mx-auto mt-8 max-w-6xl border-t border-slate-200 px-6 pt-6 text-center text-xs text-slate-400 dark:border-slate-800">
      © {new Date().getFullYear()} LoopFund by Grit Agencies. All rights reserved.
    </div>
  </footer>
  );
};
